<template>
  <a-card :bordered="false">
    <!-- 抽屉 -->
<!--    <a-drawer
      title="字典列表"
      :width="screenWidth"
      :maskClosable="false"
      @close="onClose"
      :visible="visible"
    >-->
      <!-- 抽屉内容的border -->
<!--      <div
        :style="{
          padding:'10px',
          border: '1px solid #e9e9e9',
          background: '#fff',
        }">-->

        <div class="table-page-search-wrapper">
          <a-form layout="inline" :form="form" @keyup.enter.native="searchQuery">
            <a-row :gutter="12">
              <a-col :md="7" :sm="8">
                <a-form-item :label="language['system.sysDictItem.itemText']">
                  <a-input  :placeholder="language['common.pleaseInput']+language['system.sysDictItem.itemText']" v-model="queryParam.itemText" allowClear></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="7" :sm="8">
                <a-form-item :label="language['system.sysDictItem.status']"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    :placeholder="language['common.pleaseChoose']+language['system.sysDictItem.status']"
                    v-model="queryParam.status"
                    allowClear
                  >
                    <a-select-option value="1">{{language['common.normal']}}</a-select-option>
                    <a-select-option value="0">{{language['common.disable']}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="7" :sm="8">
              <span style="float: left;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery">{{language['common.searchButton']}}</a-button>
                <a-button type="primary" @click="searchReset" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              </span>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="2" :sm="24">
                <a-button style="margin-bottom: 10px" type="primary" @click="handleAdd" v-has="'dictItemPage:insert'">{{language['common.insertButton']}}</a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div>
          <a-table
            ref="table"
            rowKey="id"
            size="middle"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            @change="handleTableChange"
            :rowClassName="getRowClassname"
          >

          <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)" v-has="'dictItemPage:edit'">{{language['common.edit']}}</a>
            <a-divider type="vertical" v-has="'dictItemPage:edit'"/>
            <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
            <a-divider type="vertical" v-has="'dictItemPage:delete'"/>
            <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)" v-has="'dictItemPage:delete'">
              <a>{{language['common.delete']}}</a>
            </a-popconfirm>
          </span>

          </a-table>
        </div>
<!--      </div>-->
<!--    </a-drawer>-->
    <dict-item-modal ref="modalForm" @ok="modalFormOk"></dict-item-modal> <!-- 字典数据 -->
  </a-card>
</template>

<script>
  import { get, pick } from 'lodash';
  import {filterObj} from '@/utils/util';
  import DictItemModal from './modules/DictItemModal'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import { getAction } from '@/api/manage'

  export default {
    name: "DictItemListPage",
    mixins: [JeecgListMixin],
    components: {DictItemModal},
    data() {
      return {
        columns: [
          {
            title: this.$store.getters.language['system.sysDictItem.itemText'],
            align: "center",
            dataIndex: 'itemText',
          },
          {
            title: this.$store.getters.language['system.sysDictItem.itemValue'],
            align: "center",
            dataIndex: 'itemValue',
          },
          {
            title: this.$store.getters.language['common.action'],
            dataIndex: 'action',
            align: "center",
            scopedSlots: {customRender: 'action'},
          }
        ],
        queryParam: {
          dictId: this.dictId,
          dictName: "",
          itemText: "",
          delFlag: "1",
          status: [],
        },
        dataSource:[],
        title: this.$store.getters.language['common.action'],
        visible: false,
        screenWidth: 800,
        model: {},
        dictId: "",
        status: 1,
        labelCol: {
          xs: {span: 5},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 12},
          sm: {span: 12},
        },
        form: this.$form.createForm(this),
        validatorRules: {
          itemText: {rules: [{required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['system.sysDictItem.itemText']}]},
          itemValue: {rules: [{required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['system.sysDictItem.itemValue']}]},
        },
        url: {
          list: "/sys/dictItem/listByDict",
          delete: "/sys/dictItem/delete",
          deleteBatch: "/sys/dictItem/deleteBatch",
        },
      }
    },
    created() {
      let dictCode = this.$route.fullPath.split("?")[1];
      if(dictCode){
        this.edit(dictCode)
      }
      // 当页面初始化时,根据屏幕大小来给抽屉设置宽度
      // this.resetScreenSize();
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      add(dictId) {
        this.dictId = dictId;
        this.edit({});
      },
      edit(dictCode) {
        getAction("/sys/dict/getDataByCode",{dictCode:dictCode}).then((res)=>{
          if(res.success){
            let record = res.result;
            if (record.id) {
              this.dictId = record.id;
            }
            this.queryParam = {}
            this.form.resetFields();
            this.model = Object.assign({}, record);
            this.model.dictId = this.dictId;
            this.model.status = this.status;
            this.visible = true;
            this.$nextTick(() => {
              this.form.setFieldsValue(pick(this.model, 'itemText', 'itemValue'))
            });
            // 当其它模块调用该模块时,调用此方法加载字典数据
            this.loadData();
          }else{
            this.dataSource = [];
          }
        })

      },
      /*search(){
        if(this.dictId){
          this.searchQuery();
        }
      },
      reset(){
        if(this.dictId){
          this.searchReset();
        }
      },*/
      getQueryParams() {
        //update--begin--autor:wangshuai-----date:20191204------for：清空总条数 teambition JT-113------
        this.ipagination.total=0;
        //update--end--autor:wangshuai-----date:20191204------for：清空总条数 teambition JT-113------
        var param = Object.assign({}, this.queryParam);
        param.dictId = this.dictId;
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        if (this.superQueryParams) {
          param['superQueryParams'] = encodeURI(this.superQueryParams)
          param['superQueryMatchType'] = this.superQueryMatchType
        }
        return filterObj(param);
      },

      // 添加字典数据
      handleAdd() {
        this.$refs.modalForm.add(this.dictId);
        this.$refs.modalForm.title = this.language['common.insertButton'];
      },
      showDrawer() {
        this.visible = true
      },
      onClose() {
        this.visible = false
        this.form.resetFields();
        this.dataSource = [];
      },
      // 抽屉的宽度随着屏幕大小来改变
      resetScreenSize() {
        let screenWidth = document.body.clientWidth;
        if (screenWidth < 600) {
          this.screenWidth = screenWidth;
        } else {
          this.screenWidth = 600;
        }
      },
      //update--begin--autor:wangshuai-----date:20191204------for：系统管理 数据字典禁用和正常区别开，添加背景颜色 teambition JT-22------
      //增加样式方法返回值
      getRowClassname(record){
        if(record.status==0){
          return "data-rule-invalid"
        }
      }
      //update--end--autor:wangshuai-----date:20191204------for：系统管理 数据字典禁用和正常区别开，添加背景颜色 teambition JT-22------
    }
  }
</script>
<style lang="less" scoped>
//update--begin--autor:wangshuai-----date:20191204------for：系统管理 数据字典禁用和正常区别开，添加背景颜色 teambition JT-22------
/deep/ .data-rule-invalid{
  background: #f4f4f4;
  color: #bababa;
}
//update--begin--autor:wangshuai-----date:20191204------for：系统管理 数据字典禁用和正常区别开，添加背景颜色 teambition JT-22------
</style>